import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../../../actions/actions";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";

const ClubsList = () => {
    const dispatch = useDispatch();
    const clubList = useSelector((state) => state.clubList.clubList.data);
    const [isFetched, setIsFetched] = React.useState(false);
    const [loader, setLoader] = React.useState(false);
    const navigate = useNavigate();

    const handleSelectClubChange = (e) => {
        const selectedClubId = e.target.value;
        localStorage.setItem("club_id", selectedClubId);
        navigate("/");
        window.location.reload();
    };

    // const handleFetchClubList = (e) => {
    //     e.preventDefault();
    //     if (!isFetched) {
    //         setLoader(true);
    //         dispatch(actions.fetchClubList()).finally(() => {
    //             setLoader(false);
    //         });
    //         setIsFetched(true);
    //     }
    // };

    React.useEffect(() => {
        if (!isFetched) {
            setLoader(true);
            dispatch(actions.fetchClubList()).finally(() => {
                setLoader(false);
            });
            setIsFetched(true);
        }
    },[])

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "50%"
            }}
        >
            <Grid
                item
                sx={{
                    width: {
                        md: "30%",
                        xs: "80%",
                    },
                }}
            >
                <Box>
                    <FormLabel
                        className="ty-uppercase-label"
                        sx={{
                            display: "block",
                            width: "100%",
                            marginBottom: "5px",
                        }}
                    >
                        Select Club
                    </FormLabel>
                    <FormControl fullWidth>
                        <Select
                            fullWidth
                            name="clubId"
                            size="small"
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            onChange={handleSelectClubChange}
                            // onOpen={handleFetchClubList}
                        >
                            {loader ? (
                                <MenuItem disabled>Loading...</MenuItem>
                            ) : (
                                clubList.map((list) => (
                                    <MenuItem key={list.clubId} value={list.clubId}>
                                        {list.clubName}
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                    </FormControl>
                </Box>
            </Grid>
        </Box>
    );
};

export default ClubsList;
